<template>
  <div :id="getIndex" :class="['programmatic-ad', { 'no-margin' : noMargin }, { 'mar-bottom-20' : bottomMargin }, { 'no-top-margin' : noTopMargin}, { 'force-728' : forceFluid  } ]">

  </div>
</template>
<script>
  /* global googletag */
  /* eslint no-undef: "error" */

  export default {
    name: 'ProgrammaticAdsComponent',
    computed: {
      getIndex () {
        return `div-gpt-ad-5023882-${this.adObject.index}`
      }
    },
    props: {
      adObject: {
        type: Object,
        required: true,
        default: () => {
          return {}
        }
      },
      noMargin: {
        type: Boolean,
        default: false
      },
      bottomMargin: {
        type: Boolean,
        default: false
      },
      noTopMargin: {
        type: Boolean,
        default: false
      },
      forceFluid: {
        type: Boolean,
        default: false
      }
    },
    mounted () {
      // We have to delay as props are not set by default on creation
      setTimeout(() => {
        this.pushDefinition()
      }, 100)
    },
    methods: {
      pushDefinition () {
        let that = this
        window.googletag.cmd.push(() => {
          let slot = window.googletag.defineSlot(that.adObject.slotName, that.adObject.slotParams, that.getIndex)
          if (slot !== null) {
            let slotService = slot.addService(googletag.pubads().addEventListener('slotRenderEnded', (event) => {
              if (event.size !== null) {
                let _el = document.getElementById(that.getIndex)
                if (_el !== null) {
                  let _frame = _el.getElementsByTagName('div').item(0).firstElementChild
                  if (_frame !== null) {
                    const height = _frame.getAttribute('height')
                    const width = _frame.getAttribute('width')
                    const _id = _frame.getAttribute('id')
                    document.getElementById(_id).style.height = `${height}px`
                    document.getElementById(_id).style.width = `${width}px`
                  }
                }
              }
            }))
            slotService.setTargeting('Pos', that.adObject.targetingParams.Pos)
            slotService.setTargeting('SlotName', that.adObject.targetingParams.SlotName)
            window.googletag.enableServices()
            window.googletag.display(that.getIndex)
          }
        })
        this.$emit('ad-loaded')
      }
    }
  }
</script>
<style scoped>
  .programmatic-ad {
    margin: 30px auto 30px auto;
    max-width: 728px!important;
    /*border: 1px solid green;*/
  }

  .programmatic-ad.no-margin {
    margin: 0 auto;
  }

  .mar-bottom-20 {
    margin-bottom: 20px;
  }

  .no-top-margin {
    margin-top: 0;
  }

  .force-728 {
    display: block;
    width: 728px;
  }

</style>



// WEBPACK FOOTER //
// src/components/ProgrammaticAds.vue